/* eslint-disable */
import { Promise } from 'es6-promise'
import { Toast } from 'antd-mobile'
import zhihuHybrid from 'zhihu-hybrid'
import uuidv4 from 'uuid/v4'
import qs from 'query-string'
import openInApp from 'zhihu-utilities/lib/openInApp'
import { subscribe } from 'subscribe-ui-event'
import { getUserStatus } from '../services'
import { formatNumber } from './number'
import { initOpenInApp } from './callApp'
import urlParser from './urlParser'

const SESSION_STORAGE_KEY = 'SESSION_STORAGE_KEY'

async function initZhihuHybrid() {
  await zhihuHybrid.ready()
}

const getIsHrybridWebView = () => /ZhihuHybrid/.test(window.navigator.userAgent)

const isHybridable = getIsHrybridWebView()

const getPlatform = () => {
  const u = navigator.userAgent
  if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) return 'android'
  if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) return 'ios'
  return 'UnKnow Platform'
}

const platform = getPlatform()

const convertToOiaUrl = url => {
  let { location } = window

  if (url) {
    location = urlParser(url)
  }

  const { host, pathname } = location
  return `https://oia.zhihu.com/hybrid?zh_url=${
    host === 'activity.zhihu.com' ? 'https' : 'http'
  }://${host}${pathname}&zh_app_id=300100`
}

const convertToUniversalUrl = url => {
  let { location } = window

  if (url) {
    location = urlParser(url)
  }

  const { pathname } = location
  if (pathname.startsWith('/activity')) {
    return `zhihu:/${platform === 'ios' ? '' : '/activity'}${pathname}`
  }
  return convertToOiaUrl(url)
}

const checkIsHybridable = () => {
  if (isHybridable) {
    return Promise.resolve()
  }

  const url = convertToUniversalUrl()
  if (url.startsWith('zhihu:/')) {
    openInApp(url)
  } else {
    window.location.href = url
  }

  return Promise.reject(new Error('请在 App 内打开页面'))
}

const checkIsLogin = () => {
  const { href, pathname } = window.location
  return getUserStatus().catch(() => {
    zhihuHybrid.dispatch('account/showLoginDialog', {
      next: pathname.startsWith('/activity') ? href : convertToOiaUrl(href),
    })
    return Promise.reject(new Error('用户未登录'))
  })
}
const initializeNativeShare = ({
  title = document.title,
  description = document.title,
  imgUrl = 'https://zhihu-beyond.zhimg.com/5f9bd795058c6578f21cd7076a18119f.svg',
  url = window.location.href,
} = {}) => {
  const zhihuMessage = {
    content: `${description} - ${url}`,
  }
  const wechatTimeline = {
    title,
    link: url,
    imgUrl,
  }
  const wechatMessage = {
    title,
    desc: description,
    link: url,
    imgUrl,
  }
  const QQ = {
    url,
    title,
    content: description,
    imageURL: imgUrl,
  }
  const Qzone = {
    url,
    title,
    content: description,
    imageURL: imgUrl,
  }
  const weibo = {
    title,
    content: `${description} - ${url}`,
    imageURL: imgUrl,
  }

  if (isHybridable) {
    zhihuHybrid.dispatch('share/setShareInfo', {
      zhihuMessage,
      wechatTimeline,
      wechatMessage,
      QQ,
      Qzone,
      weibo,
    })
  }
}

// 兼容鸿蒙系统的打开链接方法
const safeOpenUrl = url => {
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

const universalOpenUrl = url => {
  if (isHybridable) {
    // 数据构造文档： http://wiki.in.zhihu.com/pages/viewpage.action?pageId=135580144
    const payload = {
      adjson: JSON.stringify({
        ads: [
          {
            creatives: [
              {
                asset: {
                  landing_url: url,
                },
              },
            ],
          },
        ],
      }),
    }
    supportsAction('ad/open').then(isSupported => {
      if (isSupported) {
        zhihuHybrid.dispatch('ad/open', payload)
      } else {
        safeOpenUrl(url)
      }
    })
  } else {
    safeOpenUrl(url)
  }
}

const universalDispatch = func => {
  checkIsHybridable()
    .then(checkIsLogin)
    .then(func)
}

const universalToast = (text, icon) => {
  if (isHybridable) {
    zhihuHybrid.dispatch('ui/showToast', { icon, text })
  } else {
    Toast.info(text)
  }
}

const getImageHeight = height => {
  let appWidth = document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : 375
  appWidth = appWidth > 600 ? 600 : appWidth
  return Math.floor(height / 375 * appWidth)
}

const isShowed = el => {
  if (!document.body.contains(el)) {
    return false
  }

  const rect = el.getBoundingClientRect()
  const html = document.documentElement
  return rect.top < (window.innerHeight || html.clientHeight)
}

const onShowedOnce = (el, callback, context) => {
  if (isShowed(el)) {
    callback.call(context)
    return
  }
  const subscription = subscribe('scroll', () => {
    if (isShowed(el)) {
      callback.call(context)
      subscription.unsubscribe()
    }
  })
}

const supportsAction = path => {
  return zhihuHybrid.supportsAction(path)
}

const changeUrl = url => {
  if (url.indexOf('miaozhen.com') !== -1) {
    return url.replace('__IMEI__', '__IMEI_MD5__').replace('__ANDROIDID__', '__ANDROIDID_MD5__')
  } else {
    if (url.indexOf('__ORIGINAL__') !== -1) {
      return url
    } else {
      return url.replace('__IMEI__', '__IMEI_MD5__').replace('__IDFA__', '__IDFA_MD5__').replace('__ANDROIDID__', '__ANDROIDID_MD5__')
    }
  }
}

const sendTrack = url => {
  url = changeUrl(url)
  supportsAction('ad/sendTrack').then(isSupported => {
    if (isSupported) {
      zhihuHybrid.dispatch('ad/sendTrack', { tracks: [url] })
    } else {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = resolve
        image.addEventListener('error', reject)
        image.src = url
      }).catch(err => {
        console.warn('outsourcing request error: ', err)
      })
    }
  })
}

const sessionInstall = () => {
  sessionStorage.setItem(SESSION_STORAGE_KEY, uuidv4())
}

const getSession = () => {
  const uuid = sessionStorage.getItem(SESSION_STORAGE_KEY)
  if (!uuid) {
    return uuidv4()
  } else {
    return uuid
  }
}

const trackSugar = ({cti, at, et, cu = '', eu = '', md = '', ci = '', pi = '', ev = '', ctk = '', ct = ''}) => {

  const baseUrl = 'https://sugar.zhihu.com/ad-track/customization'

  const times = Math.round(new Date().getTime() / 1000)
  const query = {
    si: getSession(),
    ctt: 'activity',
    ctn: 'activity_square',
    cti,
    at,
    et,
    ev,
    ets: times,
    ci,
    ctk,
    ct,
    pi,
    md,
    cu,
    eu,
    re: window.location.href,
    idfa: '__IDFA_NO__',
    imei: '__IMEI_NO__',
    oaid: '__OAID_NO__'
  }
  const queryString = qs.stringify(query, {skipEmptyString: true, skipNull: true})
  const url = `${baseUrl}?${queryString}`
  sendTrack(url)
}

export {
  isHybridable,
  platform,
  initOpenInApp,
  initZhihuHybrid,
  convertToUniversalUrl,
  checkIsHybridable,
  checkIsLogin,
  initializeNativeShare,
  universalOpenUrl,
  universalDispatch,
  universalToast,
  formatNumber,
  getImageHeight,
  getPlatform,
  onShowedOnce,
  sendTrack,
  sessionInstall,
  trackSugar
}



// WEBPACK FOOTER //
// ./src/utils/index.js